
import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";
export const CarePlanTypeSearchDropdown = (search) => {
  return apiClient.get(`/care-plan-type/CarePlanTypeDropdown/${search}`, {
    headers: authHeader(),
  });
};

export const NursingDiagnosisSearchDropdown = (search = "") => {
  const url = search
    ? `/nursing-diagnosis/NursingDiagnosisDropdown/${search}`
    : `/nursing-diagnosis/NursingDiagnosisDropdown`;

  return apiClient.get(url, {
    headers: authHeader(),
  });
};

export const DiagnosisListing = (searchObj) => {
  return apiClient.get(`/nursing-diagnosis/list`, searchObj);
};

export const PlanRelatedFactorsListing = async (data) => {
  return await apiClient.post("/nursing-plan-related-factors/list", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const PlanGoalsListing = async (data) => {
  return await apiClient.post("/nursing-plan-goals/list", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const PlaninterventionListing = async (data) => {
  return await apiClient.post("/nursing-plan-intervention/list", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const PlanGoalsId = (id) => {
  return apiClient.get(`/nursing-plan-goals/${id}`, {
    headers: authHeader(),
  });
};

export const PlaninterventionId = (id) => {
  return apiClient.get(`/nursing-plan-intervention/${id}`, {
    headers: authHeader(),
  });
};

export const diagnosisId = (id) => {
  return apiClient.get(`/nursing-diagnosis/${id}`, {
    headers: authHeader(),
  });
};

export const PlanrelatedId = (id) => {
  return apiClient.get(`/nursing-plan-related-factors/${id}`, {
    headers: authHeader(),
  });
};

export const DiagnosisUpdate = async (data) => {
  return await apiClient.post("/nursing-diagnosis/saveOrUpdate", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const PlanRelatedFactorsUpdate = async (data) => {
  return await apiClient.post(
    "/nursing-plan-related-factors/saveOrUpdate",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const PlanGolsUpdate = async (data) => {
  return await apiClient.post("/nursing-plan-goals/saveOrUpdate", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const PlaninterventionUpdate = async (data) => {
  return await apiClient.post("/nursing-plan-intervention/saveOrUpdate", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
